import { render, staticRenderFns } from "./ModelTeamIncome.vue?vue&type=template&id=3e830adc&scoped=true&"
import script from "./ModelTeamIncome.vue?vue&type=script&lang=js&"
export * from "./ModelTeamIncome.vue?vue&type=script&lang=js&"
import style0 from "./ModelTeamIncome.vue?vue&type=style&index=0&id=3e830adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e830adc",
  null
  
)

export default component.exports